import "virtual:uno.css";
import { initConfig, useConfig } from "@nmp-js/huck/client";
import React from "react";
import ReactDOM from "react-dom/client";
import { dynamicActivate } from "../activate-locale.js";
import { Config } from "../types.js";
import { App } from "./App.js";

const root = document.querySelector("#mobility-item-insertion-landing-page-root")!;

initConfig(root);

async function hydrate() {
	const config = useConfig<Config>();
	await dynamicActivate(config.locale);
	ReactDOM.hydrateRoot(
		root,
		<React.StrictMode>
			<App />
		</React.StrictMode>,
	);
}

hydrate();
